import { useFadeUp } from '../hooks/usefadeup'
import './Parceiros.css'

// ── Data — imagens reais dos parceiros da pasta public ─────────────────
const parceiros = [
  { name: 'ARKO Seguros', src: '/1 PARCEIROS/ARKO-LOGO-qbx7agm2eux7j0lt2vzo56ppv19qhoylhj1gkjevdo.png' },
  { name: 'Ímpar', src: '/1 PARCEIROS/IMPAR-F.png' },
  { name: 'Fidelidade', src: '/1 PARCEIROS/276223080_389134663214624_5053276040946185285_n.png' },
  { name: 'Diamond Seguros', src: '/1 PARCEIROS/diamond_seguros-removebg-preview-352x313.webp' },
  { name: 'Britam', src: '/1 PARCEIROS/britam_logo-removebg-preview.webp' },
  { name: 'Mediplus', src: '/1 PARCEIROS/mediplus_logo_darkAsset-1.svg' },
]

// ── Component ──────────────────────────────────────────────────────────────
export default function Parceiros() {
  const sectionRef = useFadeUp<HTMLElement>(700)

  return (
    <section id="parceiros" className="par" ref={sectionRef}>

      {/* ── Header ── */}
      <div className="par-header" data-fade data-fade-delay="0">
        <h2 className="par-heading">Os Nossos Parceiros</h2>
      </div>

      {/* ── Logos strip ── */}
      <div className="par-strip">
        {parceiros.map(({ name, src }, i) => (
          <div
            key={name}
            className="par-logo"
            data-fade
            data-fade-delay={`${120 + i * 120}`}
          >
            <img src={src} alt={name} loading="lazy" draggable={false} />
          </div>
        ))}
      </div>

    </section>
  )
}